import React from 'react';
import { Icon } from './Icons.styles';

export const DownArrowIcon = props => (
	<Icon viewBox="0 0 20 12" {...props}>
		<path
			d="M17.104.497a1.697 1.697 0 1 1 2.4 2.4l-8.332 8.33a1.697 1.697 0 0 1-2.4 0L.497 2.953a1.697 1.697 0 0 1 2.4-2.4l7.075 7.076L17.104.497z"
			fill="currentColor"
			fillRule="nonzero"
		/>
	</Icon>
);



// WEBPACK FOOTER //
// ./src/shared/icons/DownArrowIcon.js